"use strict";

exports.__esModule = true;
exports.HclGlobal = void 0;
var _styledComponents = require("styled-components");
var HclGlobal = exports.HclGlobal = (0, _styledComponents.createGlobalStyle)([".hcl-theme{}"]);